import { ContentBlock, PullQuote } from '@/components/ui/ContentBlock'

export const BioScanDetails = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <ContentBlock label="01" title="More Than Just a Scan">
        <p>
          At Instrumental Health, you are not simply scanned, handed a report and sent on your way.
          Perhaps you have noticed changes in your energy, digestion, sleep, skin, weight or general
          wellbeing — or perhaps you feel well and simply want to take a more proactive approach to
          your health.
        </p>
      </ContentBlock>

      <ContentBlock label="02" title="Your Comprehensive Bio-Scan Report">
        <p>
          You receive the full detailed report generated from your scan, providing over 80 pages of
          information across a wide range of health and nutritional indicators.
        </p>
        <p>
          Depending on the areas assessed, this may include cardiovascular and circulatory health,
          digestive function, liver and metabolic health, respiratory function, vitamins and
          minerals, amino acids, bone and joint health, skin and connective tissue, eye health and
          other general wellbeing indicators.
        </p>
        <p>
          Your report includes the individual readings and reference ranges, giving you a
          comprehensive record of the findings from your assessment.
        </p>
      </ContentBlock>

      <ContentBlock label="03" title="Your One-to-One Feedback Session">
        <p>Information is much more useful when you understand what it means.</p>
        <p>
          Following your scan, Kandake Makonnen, BSc (Hons) Medical Herbalist, personally takes you
          through your results in a feedback session of approximately one hour.
        </p>
        <p>
          Drawing upon over 20 years of clinical experience in herbal medicine, nutrition and
          holistic health, Kandake explains the important findings in clear language, draws your
          attention to areas that may deserve greater focus and helps you recognise relevant
          patterns across your results.
        </p>
        <p>
          You also have the opportunity to ask questions rather than being left to interpret an
          extensive report by yourself.
        </p>
      </ContentBlock>

      <ContentBlock label="04" title="Your Personal Health Summary & First Steps">
        <p>
          Following your feedback, you receive a concise personalised summary highlighting the main
          areas identified from your scan.
        </p>
        <p>
          Rather than repeating your comprehensive Bio-Scan report, your summary brings together
          your key health priorities and provides practical nutritional and lifestyle first steps
          that you can begin incorporating into everyday life.
        </p>
        <p>The aim is simple:</p>
        <PullQuote>
          Understand what has been highlighted. Know where to focus your attention. Know where to
          begin.
        </PullQuote>
      </ContentBlock>
    </div>
  </section>
)
